import React from "react"
import { Box, Container, Grid } from "@mui/material"
import { makeStyles } from "makeStyles"
import Button from "components/Buttons/Button"
import Image from "next/image"
import Link from "components/i18n/Link"

import BackgroundImage from "/images/branchenloesungen/branchenloesungen.png"

import SEO from "components/SEO"
import Slider from "containers/Solutions/Slider"

import Apotheken from "/images/branchenloesungen/apotheken-masked.png"
import BTM from "/images/branchenloesungen/btm-tresore.png"

import Autohaeuser from "/images/branchenloesungen/autohaeuser-masked.png"
import AutohaeuserSchluesseltresor from "/images/branchenloesungen/autohaeuser-schluesseltresor.png"

import Filialen from "/images/branchenloesungen/filialen-masked.png"
import FilialenEinwurftresore from "/images/branchenloesungen/filialen-einwurftresore.png"

import Hotels from "/images/branchenloesungen/hotels-masked.png"
import Hotelsafes from "/images/branchenloesungen/hotelsafes.png"

const solutions = [
	{
		id: "btm",
		headline: "BTM-Tresore für Apotheken",
		content:
			"Laut Paragraf 15 des Betäubungsmittelgesetzes (BtMG) sind für die Aufbewahrung von Betäubungsmittel ausschließlich zugelassene Sicherheitsprodukte zu verwenden. Dafür kommt ein nach EN 1143-1 zertifizierter Wertschutzschrank der Sicherheitsstufe 1 oder höher in Frage. Zudem sind Betäubungsmitteltresore unter einer Tonne Gewicht fachgerecht zu verankern. Auf Wunsch liefern wir den BTM-Tresore bis zum Aufstellungsort und verankern selbigen dem Gesetz entsprechend. Mit einem Betäubungsmitteltresore von Secureo finden Apotheken, Ärzte, Krankenhäuser, Pflegeheime, Kliniken und auch Tierärzte eine gesetzeskonforme Lösung für die Verwahrung von Betäubungsmittel.",
		skewedImage: Apotheken,
		objectImage: BTM,
		buttonLink: "/c/wertschutzschraenke",
	},
	{
		id: "schluesselsafes",
		headline: "Schlüsselsafes für Autohäuser",
		content:
			"Mit einem Schlüsselsafe schaffen Sie Ordnung. Egal ob Autohaus, Werkstatt oder Hausverwaltung. Schlüsseltresore von Secureo gibt mit einem Fassungsvermögen von 4 bis 200 Schlüsseln. In der Standardausführung werden die Schlüsseltresore mit einem sicheren Doppelbartschloss samt zwei Schlüsseln ausgeliefert. Alternativ können Sie bei den meisten Modellen ein komfortables Elektronikschloss wählen. Selbstverständlich werden unsere Schlüsselsafes mit dem notwendigen Befestigungsmaterial ausgeliefert. Verwahren Sie Ihre Schlüssel sicher und übersichtlich mit einem preiswerten Schlüsselsafe von Secureo.",
		skewedImage: Autohaeuser,
		objectImage: AutohaeuserSchluesseltresor,
		buttonLink: "/c/schluesselsafes",
	},
	{
		id: "einwurftresore",
		headline: "Einwurftresore für Filialisten",
		content:
			"Einwurf- oder Deposittresor kommen dort zum Einsatz, wo Bargeld schnell, einfach und sicher verwahrt werden soll. Eignet sich dadurch ideal für Systemgastronomie, Lebensmitteleinzelhandel, Drogeriemärkte. Tankstellen oder Bäckereiketten. Der Einwurftresor lässt sich unkompliziert bedienen und jede Person kann Wertgegenstände in den Tresor einwerfen. Eine im Korpus integrierte Rückholsicherung verhindert eine unberechtigte Entnahme. Nur berechtigte Personen können den Tresor je nach Schloss entweder mit Code oder Schlüssel öffnen und gelangen so an dessen Inhalt. Damit der Einwurftresor nicht im ganzen entwendet werden kann, ist er im Boden oder in der Rückwand verankert.",
		skewedImage: Filialen,
		objectImage: FilialenEinwurftresore,
		buttonLink: "/c/einwurftresore",
	},
	{
		id: "hotelsafes",
		headline: "Hotelsafes für Unterkünfte",
		content:
			"Überzeugen Sie Ihre Gäste, dass Ihnen die Sicherheit Ihrer Wertgegenstände wirklich am Herzen liegt. Am besten mit einem zuverlässigen Hotelsafe von Secureo. All unsere Hotelsafes verfügen selbstverständlich über einen Mastercode oder einem Notschlüssel. Für den Fall sollte einmal ein Gast seinen selbst einprogrammierten persönlichen Code vergessen haben. Die Secureo Hoteltresore sind in unterschiedlichen Größen erhältlich und ein spezielles Modell bietet sogar ausreichend Platz für die sichere Verwahrung eines Laptops. Die Lieferung erfolgt so wie man es von Secureo gewohnt ist gratis frei Bordsteinkante.",
		skewedImage: Hotels,
		objectImage: Hotelsafes,
		buttonLink: "/c/hotelsafes",
	},
]

const useStyles = makeStyles()(() => ({
	headerBgImage: {
		position: "absolute",
		top: 0,
		right: 0,
		height: "650px",
		width: "50vw",
		overflow: "hidden",
		zIndex: 0,
		filter: "brightness(100%)",
		"@media only screen and (max-width: 960px)": {
			filter: "brightness(60%)",
			width: "90vw",
			opacity: 0.4,
		},
	},
	headerText: {
		maxWidth: 500,
		"@media only screen and (max-width: 960px)": {
			maxWidth: "100%",
		},
	},
	// overlap images
	backgroundImage: {
		textAlign: "center",
		borderRadius: 5,
		height: 800,
		"@media only screen and (max-width: 600px)": {
			display: "none",
		},
	},
	itemImage: {
		position: "relative",
		textAlign: "center",
		borderRadius: 5,
		height: 300,
		maxWidth: 250,
		marginLeft: "auto",
		marginRight: "auto",
		marginTop: -300,
		"@media only screen and (max-width: 600px)": {
			marginTop: 10,
		},
	},
	// slider BG
	skewedBackground: {
		position: "absolute",
		top: 0,
		right: -200,
		width: "65%",
		height: "100%",
		background: "#009CAC",
		transform: "skew(-20deg)",
	},
	// headlines
	sectionHeadline: {
		height: 70,
		width: "140%",
		marginLeft: "-40%",
		background: "#009CAC",
		marginTop: 40,
		marginBottom: -70,
		zIndex: 2,
		position: "relative",
		"@media only screen and (max-width: 600px)": {
			width: "100%",
			marginLeft: "0%",
		},
	},
	headline: {
		paddingLeft: 0,
		zIndex: 3,
		position: "relative",
		"@media only screen and (max-width: 600px)": {
			paddingLeft: 10,
			fontSize: "1.4rem",
		},
	},
	// advisory
	advisoryGrid: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		marginTop: 80,
		flexDirection: "row",
		"@media only screen and (max-width: 960px)": {
			flexDirection: "column",
		},
	},
	left: {
		width: "60%",
		marginRight: "5%",
		"@media only screen and (max-width: 960px)": {
			width: "100%",
			marginRight: "0%",
		},
	},
	right: {
		width: "35%",
		"@media only screen and (max-width: 960px)": {
			width: "100%",
		},
	},
}))

const Advisory = (buttonLink) => {
	const { classes } = useStyles()
	return (
		<div className={classes.advisoryGrid} style={{}}>
			<div className={classes.left}>
				<div>
					<strong>Individuelle Beratung erhalten</strong>
				</div>
				<p style={{ fontSize: "0.9rem" }}>
					Kontaktieren Sie uns kostenlos und unverbindlich über unser Kontaktformular oder
					rufen Sie uns an!
				</p>
			</div>
			<div className={classes.right}>
				<Link href={buttonLink}>
					<Button color="primary">Produkte entdecken</Button>
				</Link>
			</div>
		</div>
	)
}

const SolutionsPage = () => {
	const { classes } = useStyles()
	return (
		<>
			<SEO asPath={"/solutions"} title="Branchenlösungen" appendLocalizedShopNameWithPipe />
			<div style={{ backgroundColor: "#082129", minHeight: "600px", color: "white" }}>
				<div className={classes.headerBgImage}>
					<Image
						alt="Kontakt"
						src={BackgroundImage}
						quality={100}
						fill
						sizes="100vw"
						style={{
							objectFit: "cover",
						}}
					/>
				</div>
				<Container>
					<Box pt={15} pb={5} className={classes.headerText}>
						<div style={{ color: "#009CAC", textTransform: "uppercase" }}>
							Branchenlösungen
						</div>
						<h1
							style={{
								fontWeight: 100,
								letterSpacing: 0.5,
								lineHeight: 1.2,
								marginTop: 5,
							}}
						>
							Wir bieten Sicherheitslösungen für eine Vielzahl an verschiedener
							Branchen
						</h1>
						<p>
							Durch unsere Erfahrung im Projektbereich bieten wir Ihnen
							maßgeschneiderte Lösungen für Ihr Projekt oder Unternehmen in
							Österreich, Deutschland und in der Schweiz. Wir bieten Ihnen eine
							kompetente Projektabwicklunge in den unterschiedlichsten Bereichen.
						</p>
					</Box>
				</Container>
			</div>
			<Box py={5} style={{ backgroundColor: "#082129", color: "#fff" }}>
				<Box pb={7} mb={15} style={{ position: "relative", overflow: "hidden" }}>
					<div className={classes.skewedBackground} />
					<Container>
						<h2>Unsere gewerblichen Sicherheitslösungen</h2>
						<Slider />
					</Container>
				</Box>
				<Container>
					{solutions.map((solution) => {
						const { id, headline, content, skewedImage, objectImage, buttonLink } =
							solution

						const reversedItems = id === "btm" && "einwurftresore"

						return (
							<Box key={id} mb={10}>
								<Grid
									container
									spacing={3}
									id={id}
									direction={reversedItems ? "row-reverse" : "row"}
								>
									<Grid item xs={12} sm={6}>
										<div style={{ position: "relative" }}>
											<Box className={classes.sectionHeadline} />
											<h2 className={classes.headline}>{headline}</h2>
										</div>
										<br />
										<p>{content}</p>

										<Advisory buttonLink={buttonLink} />
									</Grid>
									<Grid item xs={false} sm={1} />
									<Grid item xs={12} sm={5}>
										<div style={{ position: "relative" }}>
											<div className={classes.backgroundImage}>
												<Image
													alt={id}
													title={headline}
													src={skewedImage}
													quality={100}
													fill
													sizes="100vw"
													style={{
														objectFit: "cover",
													}}
												/>
											</div>
											<div className={classes.itemImage}>
												<Image
													alt={id}
													title={headline}
													src={objectImage}
													quality={100}
													fill
													sizes="100vw"
													style={{
														objectFit: "contain",
													}}
												/>
											</div>
										</div>
									</Grid>
								</Grid>
							</Box>
						)
					})}
				</Container>
			</Box>
		</>
	)
}

export default SolutionsPage
